// Exact approved hosts only: query parameters cannot redirect to arbitrary sites.
// Keep this list in sync with sgapp-client src/pages/preview/objectivesUrl.ts.
const DEV_STUDY_HOSTS = new Set([
  'study.dev.240tutoring.com',
  'sgapp.dev.240tutoring.com',
  'd34001vcvoskd2.cloudfront.net',
  'd1pkm6cwi6dnf6.cloudfront.net',
  'd3immiatbdnalb.cloudfront.net',
  'samtest.240tutoring.com',
  'clt-dev.240tutoring.com',
  'study-dev.bestinclass.com'
]);

export function previewReturnUrl(search: string): string {
  const params = new URLSearchParams(search);
  if (params.get('from') === 'marketing-dev') return 'https://labs.dev.240.org';
  if (params.get('from') !== 'study-guide') return 'https://labs.240.org';
  const host = params.get('studyHost') ?? '';
  return DEV_STUDY_HOSTS.has(host)
    ? 'https://' + host + '/preview'
    : 'https://study.240tutoring.com/preview';
}
